import { Component, OnInit } from '@angular/core';
import { environment } from "../../../environments/environment";
import * as $ from "jquery";

@Component({
  selector: 'app-whatsupchat',
  templateUrl: './whatsupchat.component.html',
  styleUrls: ['./whatsupchat.component.css']
})
export class WhatsupchatComponent implements OnInit {


  today: number = Date.now();
  whatsAppNo: any;
  constructor() { 
    setInterval(() => {this.today = Date.now()}, 1);
  }

  ngOnInit() {
    this.whatsAppNo = environment.WHATSAPP_PHONE_NO;
  }

  waClick(){
  
    $(".wa-box-outer-1").toggle();
    
  }

}
